var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-header", { attrs: { cmlUrl: _vm.cmlUrl } }),
      _vm._v(" "),
      _c(
        _vm.currentComponent,
        _vm._b(
          { tag: "component", on: { "logged-in": _vm.loggedIn } },
          "component",
          _vm.currentProperties,
          false
        )
      ),
      _vm._v(" "),
      _c("app-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }